import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "homeReport";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //主页报表---除柱状图部分
    async GetCountReport({ commit }, payload) {
      let result = await api.get(`/api/HomeReport/Count?year=${payload}`);
      return result;
    },
    //损失柱状图报表
    async GetLossReport({ commit }, payload) {
      let result = await api.get(`/api/HomeReport/Loss?year=${payload}`);
      return result;
    },
    //物资耗用柱状图报表
    async GetConsumeReport({ commit }, payload) {
      let result = await api.get(`/api/HomeReport/Consume?year=${payload}`);
      return result;
    }
  }
});

export default moduleName;
